import { render } from "./UnwrapView.vue?vue&type=template&id=2dd200d8&scoped=true"
import script from "./UnwrapView.vue?vue&type=script&lang=js"
export * from "./UnwrapView.vue?vue&type=script&lang=js"

import "./UnwrapView.vue?vue&type=style&index=0&id=2dd200d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2dd200d8"

export default script